import React from 'react';
import Main from './main';
import History from './history';
import axios from '../axios';
import PlaceDetail from './place_detail';
import PlaceReservation from './place_reservation';

const EventEdit = (props) => {
  const [page, setPage] = React.useState(0);
  const [historyEventId, setHistoryEventId] = React.useState(null);
  const [events, setEvents] = React.useState([]);
  const [event, setEvent] = React.useState(props.event);
  const [circle, setCircle] = React.useState(props.circle);
  const [usersCircles, setUsersCircles] = React.useState(props.usersCircles || []);
  const [eventsPlans, setEventsPlans] = React.useState(props.eventsPlans || []);
  const [contents, setContents] = React.useState(props.contents || []);
  const [bodyText, setBodyText] = React.useState(() => {
    if (!props.contents) {
      return '';
    }
    const content = props.contents.find(
      (content) => content.content_type && content.content_type === 1
    );
    return content ? content.body : '';
  });
  const isAlreadyReplacedFromTemplate = React.useRef(false);
  const [selectedPlaceId, setSelectedPlaceId] = React.useState(null);
  const [selectedPlace, setSelectedPlace] = React.useState(null);
  const handleReserve = React.useCallback((place) => {
    setSelectedPlace(place);
    setPage(3);
  }, []);
  const [reservationSummary, setReservationSummary] = React.useState(null);

  React.useEffect(() => {
    if (props.circle.id){
      axios
      .get(`/api/event/history_list/${props.circle.id}`)
      .then((response) => setEvents(response.data.history_list));
    }
  }, [props.circle.id]);

  React.useEffect(() => {
    if (props.isNew || reservationSummary) return;
    axios
      .get(`/api/places/reservation_detail/${props.event.id}`)
      .then((res) => {
        if (res.data) setReservationSummary({
          id: res.data.id,
          place_id: res.data.place_id,
          place_name: res.data.place_name,
          start_at: res.data.start_at,
          end_at: res.data.end_at,
          num_people: res.data.num_people,
          request_detail: res.data.request_detail,
          reserver_name: res.data.reserver_name,
          reserver_tel: res.data.reserver_tel,
        });
      })
      .catch(() => {});
  }, [props.isNew, props.event.id, reservationSummary]);

  const handleSelectPlace = React.useCallback((placeId) => {
    setSelectedPlaceId(placeId);
    setPage(2);
  }, []);

  const handleEditReservation = React.useCallback(() => {
    if (reservationSummary?.place_id) {
      setSelectedPlace({ id: reservationSummary.place_id, name: reservationSummary.place_name });
    }
    setPage(3);
  }, [reservationSummary]);

  // テンプレートを読み込み
  React.useEffect(() => {
    if (
      !props.isNew ||
      isAlreadyReplacedFromTemplate.current ||
      props.eventsPlans.length > 0
    ) {
      return;
    }
    isAlreadyReplacedFromTemplate.current = true;

    axios
      .post(
        '/api/event/replace_event_from_template',
        JSON.stringify({
          event_id: props.event.id,
        })
      )
      .then((response) => {
        setEvent((prev) => ({ ...prev, ...JSON.parse(response.data.event) }));
        setEventsPlans(JSON.parse(response.data.events_plans));
      });
  }, [props]);

  return (
    <div>
      {page === 0 ? (
        <Main
          props={props}
          historyEventId={historyEventId}
          setPage={setPage}
          event={event}
          circle={circle}
          usersCircles={usersCircles}
          setUsersCircles={setUsersCircles}
          setEvent={setEvent}
          setCircle={setCircle}
          eventsPlans={eventsPlans}
          setEventsPlans={setEventsPlans}
          contents={contents}
          setContents={setContents}
          bodyText={bodyText}
          setBodyText={setBodyText}
          isNewPolicyApplicable={props.isNewPolicyApplicable}
          onSelectPlace={handleSelectPlace}
          reservationSummary={reservationSummary}
          onEditReservation={handleEditReservation}
        />
      ) : (
        ''
      )}
      {page === 1 ? (
        <History
          props={props}
          events={events}
          setHistoryEventId={setHistoryEventId}
          setPage={setPage}
          setEvent={setEvent}
          setEventsPlans={setEventsPlans}
          setContents={setContents}
          setBodyText={setBodyText}
        />
      ) : (
        ''
      )}
      {page === 2 && (
        <PlaceDetail
          placeId={selectedPlaceId}
          onBack={() => setPage(0)}
          onReserve={handleReserve}
        />
      )}
      {page === 3 && selectedPlace && (
        <PlaceReservation
          place={selectedPlace}
          eventId={event.id}
          eventEndDefault={ reservationSummary?.end_at || event.event_end_datetime }
          eventDateDefault={reservationSummary?.start_at || event.event_date}
          initialData={reservationSummary || {}}
          onBack={reservationSummary
            ? () => setPage(0)
            : () => setPage(2)}
          onFinish={(summary) => {
            setReservationSummary(summary);
            setEvent(prev =>
              prev.event_date
              ? prev
              : { ...prev, event_date: summary.start_at, event_end_datetime: summary.end_at }
            );
            setPage(0);
          }}
        />
      )}
    </div>
  );
};

export default EventEdit;
